import { BaseService } from 'core/services';
import PatientRouteService from './PatientRouteService';

class PatientService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new PatientRouteService());
    }
    
    async findPatients(resource){
        const url = this.routeService.findPatients(resource);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async getPatientPrimaryInsurance(id){
        const url = this.routeService.getPatientPrimaryInsurance(id);
        const response = await this.apiClient.get(url);
        return response.data || null;
    }

    async createBrightreeAndLocalPatientAndInitializeTemplate(resource) {
		const url = this.routeService.createBrightreeAndLocalPatientAndInitializeTemplate();

		const response = await this.apiClient.post(url, resource);

        return response;
	}

    updatePatientInsurance(resource) {
        const url = this.routeService.updatePatientInsurance(resource);

        return this.apiClient.put(url, resource);
    }

    updatePatientDetails(resource) {
        const url = this.routeService.updatePatientDetails(resource);

        return this.apiClient.put(url, resource);
    }

    updateOrderingDoctor(resource) {
        const url = this.routeService.updateOrderingDoctor(resource);

        return this.apiClient.put(url, resource);
    }

    updatePatientInsuranceNewFlow(resource) {
        const url = this.routeService.updatePatientInsuranceNewFlow(resource);

        return this.apiClient.put(url, resource);
    }
}

export default PatientService;
